import { useEffect, useRef } from "react";

export default function Cursor() {
  const dot = useRef(null);
  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let cx = x;
    let cy = y;
    const move = (e) => {
      x = e.clientX;
      y = e.clientY;
    };
    window.addEventListener("mousemove", move);
    let raf;
    const loop = () => {
      cx += (x - cx) * 0.2;
      cy += (y - cy) * 0.2;
      if (dot.current) dot.current.style.transform = `translate(${cx}px, ${cy}px)`;
      raf = requestAnimationFrame(loop);
    };
    loop();
    const over = (e) => {
      if (e.target.closest('[data-cursor="link"], a, button')) dot.current?.classList.add("cur-lg");
    };
    const out = (e) => {
      if (e.target.closest('[data-cursor="link"], a, button')) dot.current?.classList.remove("cur-lg");
    };
    document.addEventListener("mouseover", over);
    document.addEventListener("mouseout", out);
    return () => {
      window.removeEventListener("mousemove", move);
      cancelAnimationFrame(raf);
      document.removeEventListener("mouseover", over);
      document.removeEventListener("mouseout", out);
    };
  }, []);
  return <div ref={dot} className="cursor-dot" aria-hidden="true" />;
}
